import { z } from "zod"

import { accountPropertiesSchema } from "./account-properties"
import { genabilityAddressSchema } from "./address"
import { tariffSchema } from "./tariff"

const eligibilityFlagsSchema = z.object({
  lastUpdatedDate: z.string(),
  energyCommunityUnemployment: z.boolean(),
  energyCommunityCoalClosures: z.boolean(),
  caDisadvantagedCommunity: z.boolean(),
  iraLowIncomeCategory1: z.boolean(),
})

export const genabilityAccountSchema = z.object({
  accountId: z.string(),
  providerAccountId: z.string().nullable().optional(),
  accountName: z.string().nullable().optional(),
  customerOrgId: z.string().nullable().optional(),
  customerOrgName: z.string().nullable().optional(),
  address: genabilityAddressSchema.optional(),
  owner: z.unknown().nullable().optional(),
  status: z.enum([`ACTIVE`, `DELETED`]),
  type: z.string().nullable().optional(),
  properties: z.record(accountPropertiesSchema),
  accountManager: z.unknown().nullable().optional(),
  assignee: z.unknown().nullable().optional(),
  contacts: z.unknown().nullable().optional(),
  tariffs: z
    .array(
      tariffSchema.pick({
        masterTariffId: true,
        tariffCode: true,
        tariffName: true,
        tariffBookName: true,
        lseId: true,
        lseName: true,
        serviceType: true,
        customerClasses: true,
        privacy: true,
        customerLikelihood: true,
        endDate: true,
        closedDate: true,
        timeZone: true,
        billingPeriod: true,
        currency: true,
        minMonthlyConsumption: true,
        maxMonthlyConsumption: true,
        minMonthlyDemand: true,
        maxMonthlyDemand: true,
        hasTariffApplicability: true,
        hasNetMetering: true,
      }),
    )
    .nullable()
    .optional(),
  projects: z.unknown().nullable().optional(),
  eligibilityFlags: eligibilityFlagsSchema.optional(),
})

export type GenabilityAccount = z.infer<typeof genabilityAccountSchema>
